/**
 * Validate the data in the schedule model.
 */
class ScheduleValidation {
  constructor() {
    this.errors = {}
    this.errorMessages = {
      BOUNDS: __('Times should be between 00:00 and 24:00.'),
      ENTROPY: __('The start time should be before the end time.'),
    }
    this.min = 0 // 12:00AM
    this.max = 86400 // 24 hours
    this.valid = true
    this.feedback = null
    this.invalids = []
  }

  /**
   * Returns true if there were no invalid intervals last validation cycle.
   */
  canSave() {
    return this.invalids.length === 0
  }

  /**
   * Reset the validation.
   */
  clearErrors() {
    this.errors = {}
    this.valid = true
    this.feedback = null
    this.invalids = []
  }

  /**
   * Push an error to the error stack.
   */
  error(id, message) {
    this.errors[id] = message
  }

  /**
   * Return an array of errors for each interval.
   */
  validate(intervals) {
    const feedback = []

    for (let i = 0; i < intervals.length; i++) {
      const validBounds = this.validateBounds(intervals[i])
      const validEntropy = this.validateEntropy(intervals[i])
      const errors = []
      if ( ! validBounds) {
        errors.push('BOUNDS')
      }
      if ( ! validEntropy) {
        errors.push('ENTROPY')
      }
      feedback.push(errors)
    }

    return feedback
  }

  /**
   * Return whether the model is valid.
   *
   * Assumptions will pretend that unset time values are set and valid.
   */
  validateForm(model, assumptions = false) {
    this.clearErrors()

    const intervals = assumptions ?
      this.assume(model.intervals) :
      model.intervals

    const invalids = []
    const feedback = this.validate(intervals)
    for (let i = 0; i < feedback.length; i++) {
      if (feedback[i].length > 0) {
        invalids.push(i)
        for (const errorKey of feedback[i]) {
          this.errors[errorKey] = this.errorMessages[errorKey]
        }
      }
    }
    this.valid = invalids.length === 0
    this.feedback = feedback
    this.invalids = invalids

    return invalids
  }

  /**
   * Return a new array with missing values guessed.
   */
  assume(intervals) {
    const assumed = []
    for (let i = 0; i < intervals.length; i++) {
      assumed.push({
        start: isNaN(intervals[i].start) ? this.min : intervals[i].start,
        end: isNaN(intervals[i].end) ? this.max - 1 : intervals[i].end
      })
    }

    return assumed
  }

  /**
   * Return true if an interval is within min and max. False otherwise.
   */
  validateBounds(interval) {
    return interval.start >= this.min && interval.end < this.max
  }

  /**
   * Return true if an interval starts before it ends. False otherwise.
   */
  validateEntropy(interval) {
    return interval.start < interval.end
  }

}

export { ScheduleValidation }
